import React, { FC } from 'react'
import styles from './LayoutsMenuItem.module.scss'
import Icon, { IconType, iconName as IconName } from '@bt-react/components/Icon'
import TooltipWrapper from '@bt-react/components/TooltipWrapper'
import { LayoutType } from '../../../../dataStore/slices/layouts/layoutsSlice'

interface LayoutsMenuItem {
  layoutMenuOption: string
  layoutIconName: IconName
  tooltipText: string
  layoutType: LayoutType
  layoutsMenuItemClick: (layoutType: LayoutType) => void
  activeLayoutItem: boolean
}

const LayoutsMenuItem: FC<LayoutsMenuItem> = ({
  layoutMenuOption,
  layoutIconName,
  tooltipText,
  layoutType,
  layoutsMenuItemClick,
  activeLayoutItem
}) => (
  <div
    data-bdd={`layouts-menu-item-${layoutMenuOption}${activeLayoutItem ? '-active' : ''}`}
    className={styles['layouts-menu__options__item']}>
    <div
      data-bdd={`layouts-menu-item-${layoutMenuOption}-btn`}
      onClick={() => layoutsMenuItemClick(layoutType)}>
      <Icon
        name={layoutIconName}
        className={styles['layouts-menu__options__svg']}
      />
    </div>
    <span className={styles['layouts-menu__options__span']}>{layoutMenuOption}</span>
    <TooltipWrapper
      dataBdd={`${layoutMenuOption}-layout`}
      tooltipText={tooltipText}
      position='bottom'>
      <Icon
        name={IconType.iconName.infoCircle}
        className={styles['layouts-menu__options__item__info-icon']}
      />
    </TooltipWrapper>
  </div>
)

export default LayoutsMenuItem